import { Box, Flex, Icon } from '@chakra-ui/react';
import { useDropzone } from 'react-dropzone';
import { Upload01 } from '@kula-ai/icons-core';
import { KText } from '@/ui-library/components/text';

export const FileUpload = ({
  maxFiles = 1,
  acceptedFiles = '',
  description = '',
  handleUpload = (value, unAcceptedFiles) => {},
  inputContainerStyles = {},
  primaryColor = '',
  maxSize = undefined,
  wrapperProps = {},
  borderColor = 'primary-600',
}) => {
  const onDrop = (selectedFile, unAcceptedFiles) => {
    handleUpload(selectedFile, unAcceptedFiles);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    maxFiles,
    accept: acceptedFiles,
    maxSize: maxSize,
  });

  return (
    <Flex flexDir="column" {...wrapperProps}>
      <Box
        {...getRootProps()}
        flex="1"
        cursor="pointer"
        w="100%"
        borderRadius="16px"
        border="1px dashed"
        borderColor={primaryColor ? primaryColor : borderColor}
      >
        <Flex
          gap="10px"
          justifyContent="center"
          alignItems="center"
          p="30px 10px"
          flexDir="column"
        >
          <Flex
            gap="12px"
            alignItems="center"
            flexDir="column"
            {...inputContainerStyles}
          >
            <input {...getInputProps()} />
            <Icon
              as={Upload01}
              width="24px"
              height="24px"
              color={primaryColor ? primaryColor : 'secondary-700'}
            />
            <Flex>
              <KText size="md-medium" textAlign="center" width="max-content">
                {isDragActive ? (
                  <KText as="span" size={'md-medium'} color="secondary-900">
                    Drop your file here to upload
                  </KText>
                ) : (
                  <>
                    <KText as="span" size={'md-medium'} color="secondary-900">
                      Drag and drop file{maxFiles > 1 ? 's' : ''} or {` `}
                    </KText>
                    <KText
                      as="span"
                      textDecoration="underline"
                      size={'md-medium'}
                      color={primaryColor ? primaryColor : 'primary-500'}
                    >
                      click to upload
                    </KText>
                  </>
                )}
              </KText>
            </Flex>
          </Flex>
          {description && (
            <KText fontSize="sm" color="secondary-700" textAlign="center">
              {description}
            </KText>
          )}
        </Flex>
      </Box>
    </Flex>
  );
};
